import "./libs/owl.carousel.js";
import "./libs/lightslider.min.js";
import { binder } from "./libs/binder";
import { staticFunctions } from "./modules/module";
import { common } from "./modules/common";
import { forms } from "./modules/forms";
import { msform } from "./modules/msform";
import { mmenu } from "./modules/mobile-menu";
import { popup } from "./modules/popup";
import { sliders } from "./modules/sliders";
import { dragndrop } from "./modules/dragndrop";

// blocks
import { course_curriculum } from "./blocks/course_curriculum";

binder({
  bounds: {
    "body": [staticFunctions.addDevicesClasses(), mmenu, forms, msform, common, popup, sliders, dragndrop],
    ".product-course-curriculum": [course_curriculum],
  },
  runTests: false,
});


// WEBPACK FOOTER //
// ./assets/js/global.js